export default { 
  times: [],
  timesGames: [],
  desempenho: {}
}